/* youthfulbloom - swipeable product images on the card.
   The swipe itself is native CSS scroll-snap, so it stays smooth on touch.
   This only keeps the dots in step with the scroll position. */
(function () {
  function sync(track) {
    var dots = track.parentNode.querySelector('[data-yb-dots]');
    if (!dots) return;
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > dots.children.length - 1) i = dots.children.length - 1;
    for (var n = 0; n < dots.children.length; n++) {
      dots.children[n].classList.toggle('is-on', n === i);
    }
  }

  function init(track) {
    if (track.dataset.ybBound) return;
    track.dataset.ybBound = '1';

    /* Timer throttle rather than requestAnimationFrame - rAF is tied to
       compositing, which some embedded/background views never run. */
    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { sync(track); }, 50);
    }, { passive: true });

    var dots = track.parentNode.querySelector('[data-yb-dots]');
    if (dots) {
      dots.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-yb-dot]');
        if (!dot) return;
        e.preventDefault();
        e.stopPropagation();

        var left = track.clientWidth * Number(dot.dataset.ybDot);
        try {
          track.scrollTo({ left: left, behavior: 'smooth' });
        } catch (err) {
          track.scrollLeft = left;   /* older engines */
        }
        sync(track);
      });
    }

    sync(track);
  }

  function scan() {
    document.querySelectorAll('[data-yb-slides]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
